import { render, staticRenderFns } from "./FooterServices.vue?vue&type=template&id=60aaccec&scoped=true&"
import script from "./FooterServices.vue?vue&type=script&lang=js&"
export * from "./FooterServices.vue?vue&type=script&lang=js&"
import style0 from "./FooterServices.vue?vue&type=style&index=0&id=60aaccec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aaccec",
  null
  
)

export default component.exports